import React, { FC } from 'react';
import i18next from 'i18next';
import RedStar from '../../assets/rating/Red.png';
import GreyStar from '../../assets/rating/Grey.png';
import { useStyles } from './styles';

interface Props {
    score?: number;
    reviews?: number;
}

const RatingStars: FC<Props> = ({ score, reviews }) => {
    const classes = useStyles();

    const getStar = (index: number): string => {
        return index <= (score || 0) ? RedStar : GreyStar;
    };

    const renderBasedOnSomeReviews = (reviews: number | undefined) => {
        if (reviews) {
            return (
                <p className={classes.basedOnReviews}>
                    {i18next.t('RatingPointsComponentBasedOn')} {reviews}{' '}
                    {i18next.t('RatingPointsComponentReviews')}
                </p>
            );
        }
        return null;
    };

    return (
        <div className={classes.container}>
            <div className={classes.stars}>
                <img alt="star 1" src={getStar(1)} className={classes.starNoMargin} />
                <img alt="star 2" src={getStar(2)} className={classes.star} />
                <img alt="star 3" src={getStar(3)} className={classes.star} />
                <img alt="star 4" src={getStar(4)} className={classes.star} />
                <img alt="star 5" src={getStar(5)} className={classes.star} />
            </div>

            {renderBasedOnSomeReviews(reviews)}
        </div>
    );
};

export default RatingStars;
